import React from "react";
import type { InputRef } from "antd";
import CustomNumericFormat, { CustomNumericFormatProps } from "../../CustomNumericFormat";
import useLPDraft from "../useLPDraft";

export type LPCustomNumericFormatProps = Omit<CustomNumericFormatProps, "value" | "defaultValue" | "getInputRef"> & {
  value?: number;
};

const LPCustomNumericFormat = React.memo(
  React.forwardRef<InputRef, LPCustomNumericFormatProps>(function LPCustomNumericFormat(
    { value, onChange, onBlur, onPressEnter, ...rest },
    ref,
  ) {
    const { draft, change, commit } = useLPDraft(value);
    const inputRef = React.useRef<InputRef>(null);

    React.useImperativeHandle(ref, () => inputRef.current!);

    return (
      <CustomNumericFormat
        {...rest}
        ref={inputRef}
        value={draft ?? ""}
        onChange={change}
        onBlur={(event) => {
          commit((nextValue) => onChange?.(nextValue));
          onBlur?.(event);
        }}
        onPressEnter={(event) => {
          onPressEnter?.(event);
          if (!event.defaultPrevented && !event.nativeEvent.isComposing) {
            event.preventDefault();
            inputRef.current?.blur();
          }
        }}
      />
    );
  }),
);

export default LPCustomNumericFormat;
